module.exports = __webpack_public_path__ + "static/media/transport.360ecad4.jpg";